<template>
    <v-dialog width="1000px"
              :value="value"
              scrollable
              @input="toggleModal()"
              persistent>
        <v-card>
            <v-toolbar class="kbGold" dark text flat>
                <v-toolbar-title>Recarga Manual</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-form v-model="valid" ref="chargeBalanceForm" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            <CompanyAppList :showManageButtons="false"
                                            :selectedCompany="selectedCompanyToCharge"
                                            :selectedApp="selectedAppToCharge"
                                            @input="selectApp($event)">
                            </CompanyAppList>
                        </v-col>

                        <v-col cols="12">
                            <v-radio-group v-model="chargeBalanceData.chargeType" row>
                                <v-radio color="kbDarkBlue" label="Factura" value="factura"></v-radio>
                                <v-radio color="kbDarkBlue" label="Regalo" value="regalo"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field v-model="chargeBalanceData.amount"
                                          color="kbDarkBlue"
                                          placeholder="0"
                                          label="Cantidad"
                                          style="font-size: 13px"
                                          type="number"
                                          prefix="USD"
                                          :rules="[rules.required]"
                                          @keyup.enter="submit()">
                                <v-row class="fill-height"  align="center" slot="prepend">
                                    <v-icon color="kbDarkBlue">mdi-currency-usd</v-icon>
                                </v-row>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field v-model="chargeBalanceData.invoice"
                                          color="kbDarkBlue"
                                          v-if="chargeBalanceData.chargeType === 'factura'"
                                          label="ID Factura"
                                          :rules="[rules.required]">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea v-model="chargeBalanceData.description"
                                        color="kbDarkBlue"
                                        solo
                                        label="Descripción">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red"
                       class="mr-2"
                       outlined
                       @click="toggleModal()">
                    Cerrar
                </v-btn>

                <v-btn color="kbGold"
                       dark
                       @click="submit()"
                       :loading="loadingChargeBalance">
                    Realizar Recarga
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import CompanyAppList from '@/components/widgets/list/CompanyAppList.vue'
import rules from '@/libs/rules'
import validations from '@/libs/validations'
export default {
  components: { CompanyAppList },
  data () {
    return {
      chargeBalanceData: {
        amount: null,
        chargeType: 'factura',
        companyId: '',
        description: '',
        invoice: ''
      },
      loadingChargeBalance: false,
      rules,
      selectedAppToCharge: {},
      selectedCompanyToCharge: {},
      valid: true
    }
  },
  methods: {
    selectApp (app) {
      this.selectedAppToCharge = app
      this.selectedCompanyToCharge = app.company
      this.chargeBalanceData.companyId = this.selectedCompanyToCharge.UUID
    },
    async submit () {
      try {
        if (!validations.minimumAmount(this.chargeBalanceData.amount, 0)) return

        if (!this.$refs.chargeBalanceForm.validate()) return

        this.loadingChargeBalance = true

        const chargeBalanceData = {
          amount: this.chargeBalanceData.amount,
          companyId: this.chargeBalanceData.companyId,
          description: this.chargeBalanceData.description,
          gift: this.chargeBalanceData.chargeType === 'regalo',
          invoice: this.chargeBalanceData.chargeType === 'factura' ? this.chargeBalanceData.invoice : undefined
        }

        await this.$store.dispatch('chargeBalance', chargeBalanceData)
        this.loadingChargeBalance = false
        this.toggleModal()
      } catch (e) {
        console.error(e)
        this.loadingChargeBalance = false
      }
    },
    toggleModal () {
      this.$refs.chargeBalanceForm.reset()
      this.$emit('input', false)
    }
  },
  mounted () {
    this.selectedCompanyToCharge = this.$store.state.companies.selectedCompany
    this.selectedAppToCharge = this.$store.state.apps.selectedApp
    this.chargeBalanceData.companyId = this.selectedCompanyToCharge.UUID
  },
  props: ['value']
}
</script>
